/**
 * よくある質問の初期化
 */
export function initFaq($) {
  if ($('.s-faq').length === 0) return;

  /**
   * アコーディオン初期化関数
   *
   * ヘッダー要素とパネル要素を関連付けて、クリックで開閉できるようにする
   *
   * @param {jQuery} $heads - ヘッダー要素のjQueryオブジェクト
   * @param {string} panelSelector - パネル要素のセレクター
   * @param {boolean} defaultOpen - デフォルトで開くかどうか
   */
  function initAccordion($heads, panelSelector, defaultOpen) {
    $heads.each(function(i) {
      const $hd = $(this);
      const $panel = $hd.next(panelSelector);
      if (!$panel.length) return;

      // パネルのIDを設定 & aria設定
      const pid =
        $panel.attr('id') || panelSelector.replace(/[^\w-]/g, '') + '-' + i;
      $panel.attr('id', pid);
      $hd.attr({ role: 'button', tabindex: '0', 'aria-controls': pid });
      const expanded = !!defaultOpen;
      $hd.attr('aria-expanded', expanded);
      if (!expanded) $panel.attr('hidden', true);

      // トグル処理
      function toggle() {
        // 開閉状態を反転
        const isOpen = $hd.attr('aria-expanded') === 'true';
        $hd.attr('aria-expanded', String(!isOpen));

        // スライド表示・非表示
        if (isOpen) {
          $panel.slideUp(200, function() {
            $panel.attr('hidden', true);
          });
        } else {
          $panel.attr('hidden', false).hide().slideDown(200);
        }
      }

      // クリック、キーダウンイベント時
      $hd.on('click', toggle);
      $hd.on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  // category
  initAccordion($('.s-faq__category-title'), '.s-faq__qa-list', false);
}
